<template>
  <el-dialog v-model="isView" class="select-bot-dia" title="请选择要加入CottonBot的智能体" append-to-body width="80%">
    <div class="select-bot-main">
      <div class="cotton-bot-center cotton-bot-center-select">
        <div class="cotton-bot-center-nav">
          <div
            v-for="(item) in botGroup"
            :key="item"
            @click="changeGroup(item)"
            :class="['nav-item', botGroupActive === item.aigroupId ? 'nav-item-active' : '']"
            >
            {{ item.groupName }}
          </div>
        </div>
        <div class="cotton-bot-center-main">
          <el-row :gutter="10">
            <el-col v-for="(item, index) in aiBotList" style="margin-top: 10px;" :key="index" :span="8">
              <div class="bot-item">
                <el-checkbox v-model="item.isCheck"></el-checkbox>
                <div :class="['bot-content', item.isCheck ? 'bot-content-active' : '']" @click="item.isCheck = !item.isCheck">
                  <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-enterprise-0.png" class="logo" alt="">
                  <div class="content-info">
                    <div class="content-info-top">
                      <span class="ai-name">{{ item.name }}</span>
                    </div>
                    <div class="content-info-tip">
                      {{ item.description }}
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="isView = false">取消</el-button>
        <el-button type="primary" @click="confirm">
          确认
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
  import { ref, defineExpose, defineEmits, nextTick, computed } from 'vue'
  import { getaigrouplist, getaigroupbyid } from '@/port/clientSide/cottonBot.js'

  const emit = defineEmits(['confirm'])
  const isView = ref(false)
  const selectBot = ref([])
  const open = async (botList) => {
    isView.value = true
    await nextTick()
    await getGroup()
    selectBot.value = botList || []
  }
  const confirm = () => {
    isView.value = false
    emit('confirm', checkBot.value)
  }

  const aiBotList = ref([])
  // 选中的智能体
  const checkBot = computed(() => {
    return aiBotList.value.filter(item => { return item.isCheck })
  })
  // 智能体分组
  const botGroup = ref([])
  // 默认选中默认分组
  const defaultGroupId = 2
  const botGroupActive = ref(defaultGroupId)

  // 获取分组信息
  const getGroup = async () => {
    const { code, data } = await getaigrouplist({ curpage: 0, pagesize: 0 })
    if (code === 0) {
      botGroup.value = data.sort((a, b) => {
        // 把默认的分组排到第一个
        // 如果 a 是 aigroupId=2，则 a 排在前面（返回负数）
        if (a.aigroupId === 2) return -1;
        // 如果 b 是 aigroupId=2，则 b 排在前面（返回正数）
        if (b.aigroupId === 2) return 1;
        // 其他情况保持原有顺序（返回 0）
        return 0;
      });
      getGroupInfo()
    }
  }
  // 切换分组
  const changeGroup = async (item) => {
    botGroupActive.value = item.aigroupId
    getGroupInfo()
  }
  // 获取分组信息
  const getGroupInfo = async () => {
    const { code, data } = await getaigroupbyid({ aiGroupId: botGroupActive.value })
    if (code === 0) {
      aiBotList.value = data.listAiModel.map(item => { 
        item.name = item.appname
        // 判断一下是否已经被选中
        const index = selectBot.value.findIndex(iten => { return iten.name === item.name })
        item.isCheck = index === -1 ? false : true
        return item
      })
    }
  }
  defineExpose({
    open
  })
</script>

<style lang="scss" scoped>
  .select-bot-dia {
    :global(.el-dialog__title) {
      color: #000 !important; 
    }
  }
  .select-bot-main {
    height: 500px;
    border-bottom: 1px solid #CCC;
    padding: 10px;
    box-sizing: border-box;
  }
  .cotton-bot-center {
    display: flex;
    height: 100%;
    margin-top: 10px;
    &-nav {
      width: 130px;
      padding: 10px;
      margin-right: 10px;
      .nav-item {
        line-height: 38px;
        border-radius: 6px;
        padding: 0 10px;
        cursor: pointer;
        min-width: 50px;
        position: relative;
        .iconfont {
          position: absolute;
          right: 5px;
          display: none;
        }
      }
      .nav-item-active, .nav-item:hover {
        background-color: #F1F8FF;
        color: #5E8EFF;
      }
      .nav-item:hover .iconfont {
        display: inline-block;
      }
      
    }
    &-main {
      flex: 1;
      padding: 0 10px 10px 10px;
      :deep(.el-row) {
        align-content: flex-start;
      }
      .bot-item {
        display: flex;
        align-items: center;
        .bot-content {
          flex: 1;
          height: 120px;
          box-sizing: border-box;
          border-radius: 10px;
          border: 1px solid #F6F6FF;
          box-shadow: 0px 0px 29.8px 0px rgba(241, 246, 255, 0.5);
          background-color: #F3F6FB;
          margin-left: 8px;
          padding: 10px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .logo {
            width: 96px;
            height: 96px;
            border-radius: 10px;
            background-color: #FFF;
          }
          .content-info {
            align-self: flex-start;
            margin-left: 20px;
            margin-top: 4px;
            flex: 1;
            &-top {
              display: flex;
              justify-content: space-between;
              margin-bottom: 10px;
              .ai-name {
                font-size: 16px;
              }
              .ai-set {
                width: 60px;
              }
            }
            &-tip {
              color: #858992;
              max-height: 80px;
              overflow: hidden;
              display: -webkit-box;          /* 将元素设为弹性伸缩盒子模型 */
              -webkit-box-orient: vertical;  /* 设置子元素的排列方式 */
              -webkit-line-clamp: 5;   
            }
          }
        }
        .bot-content-active, .bot-content:hover {
          background: linear-gradient(#E3EEFF, #E3EEFF), /* 内容背景 */
          linear-gradient(45deg, rgba(185, 156, 255, 1), rgba(155, 206, 255, 1)); /* 边框背景 */
          background-clip: padding-box, border-box; /* 分别剪裁 */
          border: 1px solid transparent; /* 透明边框提供空间 */
        }
      }
    }
    &-nav, &-main {
      background: #FFF;
      border-radius: 8px;
      height: 100%;
      overflow-y: auto;
      box-sizing: border-box;
    }
  }
  .cotton-bot-center-select {
    margin-top: 0;
    .cotton-bot-center-nav {
      border: 1px solid #D7DADF;
      border-radius: 8px;
    }
  }
</style>